import React from 'react';

const AudioStreamLink = ({ 
  title = 'HTTP Audio Stream', 
  className = '', 
  size, 
  variant, 
  rotate = false, 
  onClick 
}) => {
  return (
    <i 
      className={`${className} spp-svg ${variant ? 'spp-svg-color-' + variant : ''} ${size ? 'spp-svg-size-' + size : ''} ${rotate ? 'rotate' : ''}`} 
      onClick={onClick}
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 32 32"
        fill="currentColor"
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          strokeLinejoin: 'round',
          strokeMiterlimit: 2
        }}
      >
        <title>{title}</title>
        {/* Иконка аудиопотока (ваш SVG) */}
        <path d="M12.023,23.997l-0.002,-0c-1.105,-0 -2.002,0.897 -2.002,2.001c0,1.105 0.897,2.002 2.002,2.002c1.105,0 2.002,-0.897 2.002,-2.002l-0,-7.122c-0,-0 6.001,-0.75 6.001,-0.75l0.002,3.867c-1.105,0 -2.002,0.897 -2.002,2.002c0,1.105 0.897,2.002 2.002,2.002c1.105,-0 2.002,-0.897 2.002,-2.002l-0.005,-7.003c-0.001,-0.286 -0.124,-0.559 -0.339,-0.749c-0.215,-0.189 -0.501,-0.278 -0.785,-0.242l-8,1c-0.501,0.062 -0.876,0.488 -0.876,0.992l-0,6.004Z"/>
        <path d="M9.407,22.97c0.19,-0.164 0.397,-0.311 0.616,-0.438l-0,-4.539c-0,-1.513 1.126,-2.789 2.628,-2.977c-0,0 8,-1 8,-1c0.853,-0.106 1.711,0.158 2.356,0.727c0.645,0.569 1.015,1.388 1.016,2.248l0.004,5.376c2.349,-1.13 3.972,-3.533 3.972,-6.312c-0,-3.253 -2.224,-5.99 -5.233,-6.774c-0.639,-3.207 -3.471,-5.627 -6.865,-5.627c-3.367,-0 -6.181,2.382 -6.849,5.551c-3.169,0.668 -5.552,3.483 -5.552,6.85c0,3.492 2.562,6.39 5.907,6.915Z"/>
      </svg>
    </i>
  );
};

export default AudioStreamLink;